import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import {SelectDistrict, SelectAllProvince} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal';
import {SyncConfig} from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class District_Add extends Component {

    constructor(props) {
        super(props);
        this.state = {

            Id: 0,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => {
                },
                Second_Callback: () => {
                },
                type: 1,
            },

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: 0,

            SrList: [],
            FilteredSrs: [],
            SrId: 0,

        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        if(fieldId === 'ProvinceId') {
            const tempArr = this.state.SrList
            const filteredSrs = tempArr.filter(item => item.provinceid === value)
            this.setState({
                FilteredSrs: filteredSrs,
                [fieldId]: value
            })
        }
        this.setState({[fieldId]: value})
    }

    render() {

        return (

            <div>
                <AlertModal  {...this.state.alertModalData} />
                <MainLayout/>
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle={this.state.Id == 0 ? "Add District" : "Edit District"} isShowAddBtn={false}/>
                    <div class="content">

                        <div class="card col-lg-5 col-md-5 col-sm-12 col-xs-12">
                            <div class="card-body row">
                                <form onSubmit={this.SubmitForm} novalidate>

                                    <div class="row">
                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>Province</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="ProvinceId"
                                                options={this.state.Provincelist}
                                                val={this.state.ProvinceId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.ProvinceLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div
                                            className="formInput_Container Search_InputSelectContainer col-lg-12 col-md-12 col-sm-12 col-xs-122">
                                            <label htmlFor="">Sub Recipient</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="SrId"
                                                options={this.state.FilteredSrs}
                                                val={this.state.SrId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={false}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>District Name</label>
                                            <input autocomplete="off" type="text" class="form-control" id="DistrictName"
                                                   placeholder="Enter district name" required/>
                                        </div>
                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>Latitude</label>
                                            <input autocomplete="off" type="text" class="form-control" id="lat"
                                                   placeholder="Enter Latitude" required/>
                                        </div>
                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for=""><span style={{color: "red"}}>* </span>Longitude</label>
                                            <input autocomplete="off" type="text" class="form-control" id="long"
                                                   placeholder="Enter Longitude" required/>
                                        </div>

                                        <div
                                            class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <button type="submit" id="Form_SaveBtn" class="btn btn_style1">Save</button>
                                            <button type="button" id="Form_DeleteBtn" onClick={this.onDelete}
                                                    hidden={this.state.Id == 0 ? true : false}
                                                    class="btn btn_style2">Delete
                                            </button>
                                            <Link to="/Districts">
                                                <button type="button" id="Form_CancelBtn"
                                                        class="btn btn_style3">Cancel
                                                </button>
                                            </Link>

                                            {/* Hide button for reset */}
                                            <Link style={{display: "none"}} to="/District_Add">
                                                <button id="Form_ResetBtn" type="button"
                                                        class="btn initial-btn Cancel-Form-btn Form_Btn">Reset
                                                </button>
                                            </Link>

                                        </div>

                                    </div>


                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_Districts", true, "MenuParentLink_Geography")
        // Common.AddClassToMenueLink("MenuLink_Districts")

        this.SelectProvinces(() => {
            var Id = Common.GetId()
            if (Id !== 0) {
                this.selectDistrictDetails(Id)
            }
        })

        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectALl_SubRecipient, {}, (resp) => {
            if (resp.status) {
                this.setState({
                    SrList: resp.data.map(d => ({id: d.id, name: d.short_name, ...d}))
                })
            }
        })
    }

    SelectProvinces = (Callback) => {
        this.setState({ProvinceLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Province, {}, (data) => {
            this.setState({
                ProvinceLoader: false,
                Provincelist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({ProvinceLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    selectDistrictDetails = (Id) => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_District,{},  (resp) => {
            this.props.ShowLoader({Isloading: false})
            if (resp.status) {
                const selected = resp.data.find(item => item.id === Id)
                this.LoadDataInEditMode(selected)
            }
        }, (error) => {
            this.props.ShowLoader({Isloading: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
        })
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            ProvinceId: data.provinceId,
            SrId: data.subrecipientid
        })
        $("#DistrictName").val(data.name)
        $("#lat").val(data.lat)
        $("#long").val(data.lng)

    }
    ResetForm = () => {
        this.setState({
            Id: 0,
            ProvinceId: 0,
        })
        $("#DistrictName").val("")
    }
    SubmitForm = (e) => {
        e.preventDefault()
        if (this.state.ProvinceId === 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select district"})
            setTimeout(() => {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }

        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            id: this.state.Id,
            name: $("#DistrictName").val(),
            provinceId: this.state.ProvinceId,
            lat: $('#lat').val(),
            lng: $('#long').val(),
            subrecipientid: this.state.SrId
        }
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Post", false,
            this.state.Id === 0 ? Common.APILinks.Save_District : Common.APILinks.Update_District, JSON.stringify(Parameters), (resp) => {
                if (resp.status) {
                    SyncConfig(() => {
                            if (this.state.Id !== 0)
                                $("#Form_ResetBtn").click()
                            this.ResetForm()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 1, Msg: "Saved successfully"})
                            setTimeout(() => {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        },
                        () => {
                            if (this.state.Id != 0)
                                $("#Form_ResetBtn").click()
                            this.ResetForm()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                            setTimeout(function () {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })

    }
    onDelete = () => {
        this.setState({
            alertModalData: {
                title: "Delete District",
                message: "Are you sure you want to delete this record.",
                First_Callback: () => {
                    $("#Generic-modal-CloseBtn").click();
                    this.DeleteRecord()
                },
                Second_Callback: () => {
                    $("#Generic-modal-CloseBtn").click()
                },
                type: 1,
            }
        }, () => {
            $("#Show_ArletModal").click()
        })
    }
    DeleteRecord = () => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Delete_District, {Id: this.state.Id},
            (Result) => {
                if (Result.status == true) {
                    SyncConfig(() => {
                        $("#Form_CancelBtn").click()
                        this.props.ShowLoader({Isloading: false})
                        this.props.ShowAlert({Type: 1, Msg: "Deleted Successfully."})
                        setTimeout(function () {
                            $("#Alertmsgbtn").click()
                        }, 50);
                    }, () => {
                        this.props.ShowLoader({Isloading: false})
                        this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                        setTimeout(function () {
                            $("#Alertmsgbtn").click()
                        }, 50);
                    })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(District_Add);
